import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useAppScopeStore } from '@frontend/scope';
import { InlineNotification, Text } from '@frontend/design-system';
import { SchedulingModeEditor } from './scheduling-mode-editor';
import { SchedulingMode } from './types';

type Props = {
  locationId: string;
  value: SchedulingMode;
  hasOnlineScheduling: boolean;
};

export const LocationSchedulingModeListRow = ({ locationId, value, hasOnlineScheduling }: Props) => {
  const { t } = useTranslation('schedule-settings');
  const { getScopeName } = useAppScopeStore();

  return (
    <div css={rowContainerStyles}>
      <div css={locationNameStyles}>
        <Icon name='location' size={20} css={{ flexShrink: 0 }} />
        <Text>{getScopeName(locationId)}</Text>
      </div>
      {hasOnlineScheduling ? (
        <SchedulingModeEditor locationId={locationId} value={value} />
      ) : (
        <InlineNotification status='info' size='small'>
          <Text size='small'>{t('This location doesn’t support online scheduling.')}</Text>
        </InlineNotification>
      )}
    </div>
  );
};

const rowContainerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--fabric-space-gap-md);
  padding: var(--fabric-space-padding-md);
  border: 1px solid var(--fabric-color-neutral-20);
  border-radius: var(--fabric-radius-md);
`;

const locationNameStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xxs);
`;
